import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function LoadingJobDetails() {
  return (
    <div className="container">
      <div className="header-detail">
        <div className="row">
          <div className="col-md-10 d-flex">
            <div className="d-flex align-items-center">
              <div className="img-thum mx-2">
                <Skeleton count={1} width={221} height={65} />
              </div>
            </div>
            <div className="flex-grow">
              <div className="header-content px-md-2">
                <h3>
                  <Skeleton count={1} />
                </h3>
                <p>
                  <Skeleton count={1} />
                </p>
                <p>
                  <Skeleton count={1} />
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-2 text-md-right">
            <div className="detail-company">
              <div className="name p-0">
                <h4>
                  <Skeleton count={1} />
                </h4>
                <Skeleton count={1} />
                <Skeleton count={1} height={40} width={70} />
                {/* <Link to="#" onClick={handleApply} className="btn btn-info">
                    Quick Apply
                  </Link> */}
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix" />
        <div style={{ height: "300px" }}></div>
      </div>
    </div>
  );
}
